import React from "react";
import { CardFeature } from "./card-feature.component";
import "../../scss/bookkeeping-styling-component/pricing-card.style.scss";
import { useTranslation } from "react-i18next";

interface PricingCardProps {
  planLabel: string; 
  description: string; 
  price: string;
  currency?: string;
  billingCycle?: string; 
  features: string[];
  buttonText: string;
  backgroundColor?: string;
  buttonColor?: string;
  onClick?: () => void;
}

export const PricingCard: React.FC<PricingCardProps> = ({
  planLabel,
  description,
  price,
  currency = "",
  billingCycle = "",
  features,
  buttonText,
  backgroundColor = "#ffffff",
  buttonColor = "#6750B8",
  onClick,
}) => {
  const { t } = useTranslation();
  const isTalkPrice = price === "LETS_TALK";  
  return (
    <div className="card-pricing" style={{ backgroundColor }}>
      <div className="plan-label">{t(planLabel)}</div>
      <p className="description">{t(description)}</p>

      <div className="price-section">
        <div className="price">
          {isTalkPrice ? (
            <strong className="talk-price">{t("LETS_TALK")}</strong>
          ) : (
            <>
              {currency}
              <strong>{price}</strong>
              {!isTalkPrice && billingCycle && (
                <span className="billing-cycle">{t(billingCycle)}</span>
              )}
            </>
          )}
        </div>
        <span className="fixed-price">
          {isTalkPrice ? t("SPECIAL_PRICE") : t("FIXED_PRICE")}
        </span>
      </div>

      <ul className="features">
        {features.map((feature, index) => (
          <CardFeature key={index} text={t(feature)} />
        ))}
      </ul>

      <button
        className="contact-button"
        style={{ backgroundColor: buttonColor }}
        onClick={onClick}
      >
        {t(buttonText)}
      </button>
    </div>
  );
};
